import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.spacing.S8};
`;

export { Container };
